import React from "react";
import Stack from "@mui/material/Stack";

import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const ImageUnderUpload = (props) => {
    const {file, isUploading} = props;

    return <Stack direction="column" justifyContent="center" alignItems="center" style={{border: "1px dotted #ddd"}}>
        {
            isUploading ? <CircularProgress size={40}/> : <Typography>In coda...</Typography>
        }
        <>
            <Typography textAlign="center" variant="caption">{file.name}</Typography>
        </>
    </Stack>
}

export default ImageUnderUpload;